import { render } from "./exgInvCode.vue?vue&type=template&id=23358db2&scoped=true"
import script from "./exgInvCode.vue?vue&type=script&lang=js"
export * from "./exgInvCode.vue?vue&type=script&lang=js"

import "./exgInvCode.vue?vue&type=style&index=0&id=23358db2&lang=less&scoped=true"

import exportComponent from "D:\\myWorkspace\\CoreServiceAzure\\CoreServiceCloud\\MyNews\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23358db2"]])

export default __exports__